import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import { PAGE_TYPE } from '@/app/common/pageType.ts';

export const PRICE_TOGGLE_SELECTED = 'PRICE_TOGGLE_SELECTED';
export const PRICE_TOGGLE_SELECTED_VERSION = '1.0';

export enum PRICE_TOGGLE_SELECTED_ACTION {
  ACTIVATED = 'Activated',
  DEACTIVATED = 'Deactivated',
}

// 'Hotel Detail' / 'Flight Detail' are the same strings ChangeFlightPage already sends for this split.
export enum PRICE_TOGGLE_SELECTED_PAGE {
  RESULT = 'Result',
  HOTEL_DETAIL = 'Hotel Detail',
  FLIGHT_DETAIL = 'Flight Detail',
}

// A missing pageType means the results page, as everywhere else (see getPageTypeFromSearchParams).
const getPage = (pageType: string | undefined): PRICE_TOGGLE_SELECTED_PAGE => {
  if (pageType === PAGE_TYPE.HOTEL_DETAIL) return PRICE_TOGGLE_SELECTED_PAGE.HOTEL_DETAIL;
  return pageType === PAGE_TYPE.TRANSPORT_DETAIL
    ? PRICE_TOGGLE_SELECTED_PAGE.FLIGHT_DETAIL
    : PRICE_TOGGLE_SELECTED_PAGE.RESULT;
};

export type PriceToggleSelectedParams = {
  searchId: string;
  searchParams: SearchParams;
  showTotalPrice: boolean;
};

export type PriceToggleSelectedPayload = {
  searchId: string;
  action: string;
  page: string;
};

export const createPriceToggleSelectedPayload = ({
  searchId,
  searchParams,
  showTotalPrice,
}: PriceToggleSelectedParams): PriceToggleSelectedPayload => ({
  searchId: searchParams[URLParameters.SEARCH_ID] || searchId,
  action: showTotalPrice ? PRICE_TOGGLE_SELECTED_ACTION.ACTIVATED : PRICE_TOGGLE_SELECTED_ACTION.DEACTIVATED,
  page: getPage(searchParams[URLParameters.PAGE_TYPE]),
});
